export default __webpack_public_path__ + "static/5-9d9116a9104a3868b0e80992025308dd.png";